import React from "react";
import classNames from "classnames";
import { Switch } from "@headlessui/react";

const SIZE_CLASSES = {
    default: { track: "h-6 w-11", thumb: "h-5 w-5", translate: "translate-x-5" },
    small: { track: "h-5 w-9", thumb: "h-4 w-4", translate: "translate-x-4" }
};

const Toggle = ({ checked, onChange, disabled, ariaLabel, size = "default" }) => {
    const sizeClasses = SIZE_CLASSES[size] || SIZE_CLASSES.default;

    return (
        <Switch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            aria-label={ariaLabel}
            className={classNames(
                checked ? "bg-standart-ocean" : "bg-gray-200",
                sizeClasses.track,
                "relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out disabled:opacity-50"
            )}
        >
            <span
                aria-hidden="true"
                className={classNames(
                    checked ? sizeClasses.translate : "translate-x-0",
                    sizeClasses.thumb,
                    "pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                )}
            />
        </Switch>
    );
};

export default Toggle;
